import { I18n } from '@calendly/i18n'


export const determineDateOverridesLabel = (dateOverridesLength, hasWeekdayIntervals) => {
  if (hasWeekdayIntervals) {
    return I18n.t('publisher.event_type_editor.sections.available_hours.date_overrides.summary.with_plus_sign', {
      count: dateOverridesLength
    })
  }
  return I18n.t('publisher.event_type_editor.sections.available_hours.date_overrides.summary.without_plus_sign', {
    count: dateOverridesLength
  })
}

export const hasWeekdayIntervals = (availabilityRule) => (availabilityRule?.rules?.filter((rule) => rule?.type === 'wday')?.length ?? 0) > 0
